import { render, staticRenderFns } from "./usersaddorupdate.vue?vue&type=template&id=59560d04"
import script from "./usersaddorupdate.vue?vue&type=script&lang=js"
export * from "./usersaddorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports